import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FilterArrayModel, FilterModel } from "../../models/FilterModel";

const initialFilterState: FilterArrayModel = {
    all_Filters: [],
    particular_Filter: {
        "filterId": 0,
        "name": "",
        "description": ""
    }
}
const FilterSlice = createSlice({
    name: 'Filter',
    initialState: initialFilterState,
    reducers: {
        setFilters(state, action: PayloadAction<FilterModel[]>) {
            state.all_Filters = action.payload;
        },
        setParticularFilter(state, action: PayloadAction<FilterModel>) {
            state.particular_Filter = action.payload;
        }
    }
})
export default FilterSlice;